import { attributeChanged, define } from '@directive'
import Echo from '@echo'
import { customEvent } from '@event'
import { around } from '@middleware'
import { Headless } from '@mixin'
import { dispatch } from './interfaces'
import { Storage } from './storage'

// `upsert` names the key field used by Storage#push to merge records instead of duplicating them.
@define('kb-dataset')
class Dataset extends Echo(Headless(HTMLElement)) {
  #storage = Storage.from(this)
  #upsert

  get upsert() {
    return this.#upsert
  }

  @attributeChanged('upsert')
  set upsert(value) {
    this.#upsert = value
  }

  get value() {
    return this.#storage.values
  }

  // @around(dispatch) fires a 'changed' event after the mutation completes.
  @around(dispatch)
  delete(key) {
    this.#storage.delete(key)
    return this
  }

  [dispatch]() {
    this.dispatchEvent(customEvent('changed', this.value))
    return this
  }

  @around(dispatch)
  push(data) {
    this.#storage.push(data)
    return this
  }

  @around(dispatch)
  reset() {
    this.#storage.clear()
    return this
  }
}

export default Dataset
